/**
 * src/utils/undoRedo/commands/MoveCommand.js
 * Nesne taşıma komutu
 */

import BaseCommand from './BaseCommand';
import { clearSelection } from '../../../redux/selectionSlice';

class MoveCommand extends BaseCommand {
  /**
   * @param {Object} positionMap - { [id]: { before: {x,y,z}, after: {x,y,z} } }
   */
  constructor(positionMap) {
    super('MOVE_OBJECTS', {
      before: positionMap,
      after: positionMap
    });
    this.positionMap = positionMap;
  }

  /**
   * Redo: after pozisyonlarına taşı
   */
  execute(scene, dispatch) {
    scene.traverse(obj => {
      const entry = this.positionMap[obj.userData?.id];
      if (entry) {
        if (obj.matrixAutoUpdate === false) {
          // OCS block: matrix translation
          obj.matrix.elements[12] = entry.after.x;
          obj.matrix.elements[13] = entry.after.y;
          obj.matrix.elements[14] = entry.after.z;
          obj.matrixWorldNeedsUpdate = true;
        } else {
          obj.position.set(entry.after.x, entry.after.y, entry.after.z);
        }
      }
    });
    if (dispatch) dispatch(clearSelection());
  }

  /**
   * Undo: before pozisyonlarına geri taşı
   */
  undo(scene, dispatch) {
    scene.traverse(obj => {
      const entry = this.positionMap[obj.userData?.id];
      if (entry) {
        if (obj.matrixAutoUpdate === false) {
          // OCS block: matrix translation
          obj.matrix.elements[12] = entry.before.x;
          obj.matrix.elements[13] = entry.before.y;
          obj.matrix.elements[14] = entry.before.z;
          obj.matrixWorldNeedsUpdate = true;
        } else {
          obj.position.set(entry.before.x, entry.before.y, entry.before.z);
        }
      }
    });
    if (dispatch) dispatch(clearSelection());
  }
}

export default MoveCommand;
